import { z } from 'zod';

export const lulaPostMessageSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('unknown'),
  }),
  z.object({
    type: z.literal('LULA_READY'),
    version: z.string(),
    timestamp: z.number(),
    payload: z.object({
      authenticated: z.boolean(),
      memberId: z.string(), // User's phone number
    }),
  }),
  z.object({
    type: z.literal('NAVIGATION'),
    version: z.string(),
    timestamp: z.number(),
    payload: z.object({
      path: z.string(),
      previousPath: z.string(),
    }),
  }),
]);
